// import { Home, Zap, ShoppingCart, User, Bell, Upload, Calendar, ShoppingBag, Droplet, Wifi, Tv, ArrowLeft, Cloud, CheckSquare, Settings, CreditCard, HelpCircle, Smartphone, Flame } from 'lucide-react';
// import HomeApp from './home';
// import PayBillScreen from './paybill';
// import React, { useState } from 'react';
// import MarketplaceScreen from './marketplace';
// import ProfileScreen from './profile';
// import OrderScreen from '../dashboardprofile/myorder';
// import KycUpdate from '../dashboardprofile/kycUpdate';
// import ProductView from '../marketplace/productview';
// import PayEBill from '../bill/payebill';
// import PayEBillProviderDetails from '../bill/payEBillProviderDetails';

// const NavIconMap = {
//     home: Home,
//     payment: Zap,
//     orders: ShoppingCart,
//     profile: User
// }

// const DashApp = () => {
//     // State to manage the active screen. Default to 'home'.
//     const [activeScreen, setActiveScreen] = useState('home');

//     // Function to render the correct screen based on state
//     const renderScreen = () => {
//         switch (activeScreen) {
//             case 'home':
//                 return <HomeApp setActiveScreen={setActiveScreen} />;
//             case 'payment':
//                 return <PayBillScreen setActiveScreen={setActiveScreen}/>;
//             case 'paymentebill':
//                 return <PayEBill onBack={() => setActiveScreen('payment')} setActiveScreen={setActiveScreen} />;
//                   case 'paymentEBillProviderDetails':
//                 return <PayEBillProviderDetails onBack={() => setActiveScreen('paymentebill')} />;
//             case 'orders':
//                 return <MarketplaceScreen setActiveScreen={setActiveScreen} />;
//             case 'marketplaceProductView':
//                 return <ProductView onBack={() => setActiveScreen('orders')} />;
//             case 'profile':
//                 return <ProfileScreen setActiveScreen={setActiveScreen} />;
//             case 'order': // The 'My order' screen
//                 return <OrderScreen onBack={() => setActiveScreen('profile')} />;
//             case 'kycupdate': // The 'My order' screen
//                 return <KycUpdate onBack={() => setActiveScreen('profile')} />;
//             default:
//                 // Fallback screens for the other two icons (Orders/Profile)
//                 return (
//                     <div className="p-8 text-center text-gray-500 flex-1 flex flex-col items-center justify-center">
//                         <Settings className="w-10 h-10 mb-4" />
//                         <h1 className="text-xl font-bold capitalize">{activeScreen} Screen</h1>
//                         <p>This screen is a placeholder.</p>
//                     </div>
//                 );
//         }
//     };

//     // Component for a single navigation item
//     // const NavItem = ({ iconName, label, screenName }) => {
//     //     const isActive = activeScreen === screenName;
//     //     const Icon = NavIconMap[iconName];

//     //     // Navigation bar active state matching the blue icon in the image
//     //     const colorClass = isActive ? 'text-blue-600' : 'text-gray-500 hover:text-blue-700';
//     //     const bgClass = isActive ? 'bg-blue-50/50' : 'bg-transparent';
//     //     const shadowClass = isActive ? 'shadow-inner' : '';

//     //     return (
//     //         <button
//     //             className={`flex flex-col items-center justify-center w-1/4 py-2 transition-colors duration-200`}
//     //             onClick={() => setActiveScreen(screenName)}
//     //         >
//     //             <div className={`p-1.5 rounded-xl ${bgClass} ${shadowClass} transition-all`}>
//     //                 <Icon className={`w-6 h-6 ${colorClass}`} strokeWidth={2.2} />
//     //             </div>

//     //         </button>
//     //     );
//     // };

//     const NavItem = ({ iconName, label, screenName }) => {
//         // Handle 'order' screen being active for the 'orders' nav item (optional visual link)
//         const isActive = activeScreen === screenName
//         const Icon = NavIconMap[iconName];

//         const colorClass = isActive ? 'text-blue-600' : 'text-gray-500 hover:text-blue-700';
//         const bgClass = isActive ? 'bg-blue-50/50' : 'bg-transparent';
//         const shadowClass = isActive ? 'shadow-inner' : '';

//         return (
//             <button
//                 className={`flex flex-col items-center justify-center w-1/4 py-2 transition-colors duration-200`}
//                 onClick={() => setActiveScreen(screenName)}
//             >
//                 <div className={`p-1.5 rounded-xl ${bgClass} ${shadowClass} transition-all`}>
//                     <Icon className={`w-6 h-6 ${colorClass}`} strokeWidth={2.2} />
//                 </div>
//             </button>
//         );
//     };
//     const isOrderScreen = (activeScreen === 'order' || activeScreen === 'kycupdate' || activeScreen === 'paymentEBillProviderDetails');

//     console.log("active screen", activeScreen)
//     return (
//         <div className="min-h-screen flex justify-center bg-gray-200">
//             <div className="relative w-full max-w-md flex flex-col min-h-screen bg-gray-50 shadow-2xl">

//                 {/* Screen Rendering Area */}
//                 <div className="flex-1 overflow-y-auto">
//                     {renderScreen()}
//                 </div>


//                 {!isOrderScreen && (
//                     <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-2xl p-3 z-30 max-w-md mx-auto rounded-t-2xl">
//                         <div className="flex justify-around items-center h-full">
//                             <div className="flex flex-col items-center text-blue-600 font-semibold text-xs">
//                                 <NavItem iconName="home" label="Home" screenName="home" />
//                             </div>
//                             <div className="flex flex-col items-center text-gray-500 hover:text-blue-600 transition-colors">
//                                 <NavItem iconName="payment" label="Payment" screenName="payment" />
//                             </div>
//                             <div className="flex flex-col items-center text-gray-500 hover:text-blue-600 transition-colors">
//                                 <NavItem iconName="orders" label="Orders" screenName="orders" />
//                             </div>
//                             <div className="flex flex-col items-center text-gray-500 hover:text-blue-600 transition-colors">
//                                 <NavItem iconName="profile" label="Profile" screenName="profile" />
//                             </div>
//                         </div>
//                     </nav>
//                 )}

//             </div>
//         </div>
//     );
// };

// export default DashApp



import { Home, Zap, Loader2, RefreshCw, ShoppingCart, User, Bell, Upload, Calendar, ShoppingBag, Droplet, Wifi, Tv, ArrowLeft, Cloud, CheckSquare, Settings, CreditCard, HelpCircle, Smartphone, Flame, WifiOff, UserSearch } from 'lucide-react';
import HomeApp from './home';
import PayBillScreen from './paybill';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import MarketplaceScreen from './marketplace';
import ProfileScreen from './profile';
import OrderScreen from '../dashboardprofile/myorder';
import KycUpdate from '../dashboardprofile/kycUpdate';
// I assume ProductView is now the wrapper component that manages both Product Detail and Checkout
import ProductViewWrapper from '../marketplace/productview';
import PayEBill from '../bill/payebill';
import PayEBillProviderDetails from '../bill/payEBillProviderDetails';
import NewMeterApplicationWrapper from '../dashboardhome/newMeterApplication';
import ActiveApplicationWrapper from '../dashboardhome/activeApplication';
import { useNavigate } from 'react-router-dom';

import PullToRefresh from 'react-pull-to-refresh';
import { Network } from '@capacitor/network';
import SelfieCaptureScreen from '../profile/selfie';
import SelectBillerScreen from '../bill/payebill';
import { useBackHandler } from '../../hooks/androidbackHandler';
import { API_BASE_URL } from '../../config/api';





const SESSION_API_URL = `${API_BASE_URL}/auth/session`;

const NavIconMap = {
    home: Home,
    payment: Zap,
    orders: ShoppingCart,
    profile: User
}

// const DashApp = () => {
//     // State to manage the active screen. Default to 'home'.
//     const [activeScreen, setActiveScreen] = useState('home');

//     // Function to render the correct screen based on state
//     const renderScreen = () => {
//         switch (activeScreen) {
//             case 'home':
//                 return <HomeApp setActiveScreen={setActiveScreen} />;

//                   case 'meter_application':
//                 // The wrapper manages internal steps ('details', 'address')
//                 // onBack goes to the main 'home' screen
//                 return <NewMeterApplicationWrapper onBack={() => setActiveScreen('home')} setActiveScreen={setActiveScreen} />;
//                   case 'active_application':
//                 // The wrapper manages internal steps ('details', 'address')
//                 // onBack goes to the main 'home' screen
//                 return <ActiveApplicationWrapper onBack={() => setActiveScreen('home')} setActiveScreen={setActiveScreen} />;

//             case 'payment':
//                 return <PayBillScreen setActiveScreen={setActiveScreen}/>;
//             case 'paymentebill':
//                 return <PayEBill onBack={() => setActiveScreen('payment')} setActiveScreen={setActiveScreen} />;
//             case 'paymentEBillProviderDetails':
//                 return <PayEBillProviderDetails onBack={() => setActiveScreen('paymentebill')} />;
//             case 'orders':
//                 return <MarketplaceScreen setActiveScreen={setActiveScreen} />;


//             // --- UPDATED NAVIGATION FOR MARKETPLACE & CHECKOUT ---
//             case 'marketplaceProductView':
//                 // The ProductViewWrapper handles both product detail and checkout views internally,
//                 // but its navigation methods must be aligned with DashApp's state management.
//                 // onBack goes to the Marketplace ('orders')
//                 return <ProductViewWrapper onBack={() => setActiveScreen('orders')} setActiveScreen={setActiveScreen} />; 

//             case 'checkoutView':
//                 // This screen is also handled by the ProductViewWrapper component, 
//                 // but setting a distinct state allows us to hide the Nav Bar.
//                 // onBack goes to the Product View detail page ('marketplaceProductView')
//                 return <ProductViewWrapper onBack={() => setActiveScreen('marketplaceProductView')} setActiveScreen={setActiveScreen} />;

//             // --- END UPDATED NAVIGATION ---

//             case 'profile':
//                 return <ProfileScreen setActiveScreen={setActiveScreen} />;
//             case 'order': // The 'My order' screen
//                 return <OrderScreen onBack={() => setActiveScreen('profile')} />;
//             case 'kycupdate': // The 'My order' screen
//                 return <KycUpdate onBack={() => setActiveScreen('profile')} />;
//             default:
//                 // Fallback screens for the other two icons (Orders/Profile)
//                 return (
//                     <div className="p-8 text-center text-gray-500 flex-1 flex flex-col items-center justify-center">
//                         <Settings className="w-10 h-10 mb-4" />
//                         <h1 className="text-xl font-bold capitalize">{activeScreen} Screen</h1>
//                         <p>This screen is a placeholder.</p>
//                     </div>
//                 );
//         }
//     };

//     // Component for a single navigation item
//     const NavItem = ({ iconName, label, screenName }) => {
//         // Handle 'order' screen being active for the 'orders' nav item (optional visual link)
//         const isActive = activeScreen === screenName
//         const Icon = NavIconMap[iconName];

//         const colorClass = isActive ? 'text-blue-600' : 'text-gray-500 hover:text-blue-700';
//         const bgClass = isActive ? 'bg-blue-50/50' : 'bg-transparent';
//         const shadowClass = isActive ? 'shadow-inner' : '';

//         return (
//             <button
//                 className={`flex flex-col items-center justify-center w-1/4 py-2 transition-colors duration-200`}
//                 onClick={() => setActiveScreen(screenName)}
//             >
//                 <div className={`p-1.5 rounded-xl ${bgClass} ${shadowClass} transition-all`}>
//                     <Icon className={`w-6 h-6 ${colorClass}`} strokeWidth={2.2} />
//                 </div>
//             </button>
//         );
//     };

//     // Check if the current screen should hide the bottom navigation bar
//     const isOrderScreen = (
//         activeScreen === 'order' || 
//         activeScreen === 'kycupdate' || 
//         activeScreen === 'paymentEBillProviderDetails' ||
//         activeScreen === 'marketplaceProductView' || // Added to hide nav on detail page
//         activeScreen === 'checkoutView' || // Added to hide nav on checkout page
//         activeScreen === 'meter_application' ||
//            activeScreen === 'active_application' 
//     );

//     console.log("active screen", activeScreen)
//     return (
//         <div className="min-h-screen flex justify-center bg-gray-200">
//             <div className="relative w-full max-w-md flex flex-col min-h-screen bg-gray-50 shadow-2xl">

//                 {/* Screen Rendering Area */}
//                 <div className="flex-1 overflow-y-auto">
//                     {renderScreen()}
//                 </div>


//                 {/* Conditional Navigation Bar */}
//                 {!isOrderScreen && (
//                     <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-2xl p-3 z-30 max-w-md mx-auto rounded-t-2xl">
//                         <div className="flex justify-around items-center h-full">
//                             <div className="flex flex-col items-center text-blue-600 font-semibold text-xs">
//                                 <NavItem iconName="home" label="Home" screenName="home" />
//                             </div>
//                             <div className="flex flex-col items-center text-gray-500 hover:text-blue-600 transition-colors">
//                                 <NavItem iconName="payment" label="Payment" screenName="payment" />
//                             </div>
//                             <div className="flex flex-col items-center text-gray-500 hover:text-blue-600 transition-colors">
//                                 <NavItem iconName="orders" label="Orders" screenName="orders" />
//                             </div>
//                             <div className="flex flex-col items-center text-gray-500 hover:text-blue-600 transition-colors">
//                                 <NavItem iconName="profile" label="Profile" screenName="profile" />
//                             </div>
//                         </div>
//                     </nav>
//                 )}

//             </div>
//         </div>
//     );
// };

// const DashApp = ({ setAuthToken, setUserSession, userSession, authToken }) => {

//     // State to manage the active screen. Default to 'home'.
//     const navigate = useNavigate();
//     const [activeScreen, setActiveScreen] = useState('home');
//     const [selectedProductId, setSelectedProductId] = useState(null);

//     const [isLoading, setIsLoading] = useState(false);
//     const [error, setError] = useState(null);
//     // ... rest of the code
//     // 💡 NEW STATE: Check internet connectivity
//     const [isOnline, setIsOnline] = useState(navigator.onLine);

//     // 💡 NEW HELPER FUNCTION to handle screen switching AND data
//     const navigateToScreen = (screenName, payload = {}) => {
//         console.log(screenName,'test screen name ')
//         setActiveScreen(screenName);

//         // Specifically handle marketplace product view
//         if (screenName === 'marketplaceProductView') {
//             setSelectedProductId(payload.productId);
//         } else {
//             setSelectedProductId(null); // Clear ID when navigating away
//         }
//     };

//   const handleSignOut = () => {
//         console.log("Signing out and clearing token.");
//         // 💡 NEW: Clear token from localStorage
//         localStorage.removeItem('authToken'); 
//         setAuthToken(null);
//         setUserSession(null);
//         navigate('/signin');
//     }

//     // Function to fetch session data using the Bearer token (Wrapped in useCallback)
//     // const fetchSession = useCallback(async () => {
//     //     if (!authToken) {
//     //         handleSignOut();
//     //         return;
//     //     }

//     //     // Only set loading if session data is not yet available
//     //     if (!userSession) setIsLoading(true);
//     //     setError(null);

//     //     try {
//     //         const response = await fetch(SESSION_API_URL, {
//     //             method: 'GET',
//     //             headers: {
//     //                 'Authorization': `Bearer ${authToken}`,
//     //                 'Content-Type': 'application/json',
//     //             },
//     //         });

//     //         const result = await response.json();

//     //         // Correctly extract user from result.data.user
//     //         if (response.ok && result.data?.user) {
//     //             console.log('Session Data Received:', result);
//     //             setUserSession(result.data.user);
//     //             console.log('Session Data Received here is :', userSession, setUserSession);
//     //         } else {
//     //             console.error('Session Error:', result);
//     //             setError(result.message || 'Session validation failed. Signing out.');
//     //             handleSignOut(); // Sign out on failure or lack of user data
//     //         }
//     //     } catch (err) {
//     //         console.error('Network Error during session check:', err);
//     //         setError('Could not connect to session endpoint to verify token.');
//     //         // Do not immediately sign out on network error, allow retry
//     //     } finally {
//     //         setIsLoading(false);
//     //     }
//     // }, [authToken, setUserSession]);

//     // // Effect to trigger session fetch on component mount or token change
//     // useEffect(() => {
//     //     // *** ADDED: Debug log for user to check token presence ***
//     //     console.log(authToken, setAuthToken, userSession, setUserSession, 'DashApp useEffect - AuthToken Check:', authToken ? 'Token Present' : 'Token Undefined/Null');

//     //     // Only run fetch if we have a token and haven't loaded the user session yet
//     //     if (authToken && !userSession) {
//     //         fetchSession();
//     //     } else if (userSession) {
//     //         // If the user session is already loaded (e.g., component re-rendered), stop loading
//     //         setIsLoading(false);
//     //     } else if (!authToken) {
//     //         // If there's no token (should be caught by ProtectedRoute), still handle loading state
//     //         setIsLoading(false);
//     //     }
//     // }, [authToken, userSession, fetchSession]);


//     const fetchSession = useCallback(async () => {
//         if (!authToken || !isOnline) { // Check if offline
//             if (!authToken) handleSignOut();
//             // If we have a token but are offline, we'll wait for reconnection.
//             return;
//         }

//         if (!userSession) setIsLoading(true);
//         setError(null);

//         try {
//             const response = await fetch(SESSION_API_URL, {
//                 method: 'GET',
//                 headers: {
//                     'Authorization': `Bearer ${authToken}`,
//                     'Content-Type': 'application/json',
//                 },
//             });

//             const result = await response.json();

//             if (response.ok && result.data?.user) {
//                 console.log('Session Data Received:', result);
//                 setUserSession(result.data.user);
//             } else {
//                 console.error('Session Error:', result);
//                 setError(result.message || 'Session validation failed. Signing out.');
//                 handleSignOut(); 
//             }
//         } catch (err) {
//              // 💡 ENHANCEMENT: Catch network errors specifically
//             console.error('Network Error during session check:', err);
//             setError('Could not connect to server. Please check your internet connection.');
//         } finally {
//             setIsLoading(false);
//         }
//     }, [authToken, setUserSession, isOnline, userSession, navigate]);


//     // 💡 NEW EFFECT: Network Connectivity Listener (Point 2)
//     useEffect(() => {
//         const handleOnline = () => setIsOnline(true);
//         const handleOffline = () => setIsOnline(false);

//         window.addEventListener('online', handleOnline);
//         window.addEventListener('offline', handleOffline);

//         // Cleanup listeners
//         return () => {
//             window.removeEventListener('online', handleOnline);
//             window.removeEventListener('offline', handleOffline);
//         };
//     }, []);

//     // Effect to trigger session fetch on component mount or token/online status change
//     useEffect(() => {
//         // Only run fetch if we have a token, haven't loaded the user session, AND are online
//         if (authToken && !userSession && isOnline) {
//             fetchSession();
//         } else if (userSession || !authToken) {
//             setIsLoading(false);
//         }
//     }, [authToken, userSession, fetchSession, isOnline]);
//     // Function to render the correct screen based on state
//     // Function to render the correct screen based on state
//     const renderScreen = () => {

//         // 💡 NEW: Handle Offline Status FIRST
//         if (!isOnline) {
//              return (
//                 <div className="min-h-full flex flex-col items-center justify-center p-6 text-center flex-1 bg-white">
//                     <WifiOff className="w-12 h-12 text-red-500 mb-4" />
//                     <p className="text-xl font-bold text-gray-800 mb-2">You are Offline</p>
//                     <p className="text-gray-600">Please check your internet connection and try again.</p>
//                 </div>
//             );
//         }
//         if (isLoading || !userSession) {
//             return (
//                 <div className="min-h-full flex flex-col items-center justify-center p-6 text-center flex-1">
//                     <Loader2 className="w-8 h-8 text-blue-600 mb-4 animate-spin" />
//                     <p className="text-gray-600">Verifying session...</p>
//                     {error && (
//                         <div className="mt-4 p-3 bg-red-100 text-red-700 rounded-xl w-full max-w-sm">
//                             <p className="font-medium mb-2">{error}</p>
//                             <button onClick={fetchSession} className="text-blue-600 hover:text-blue-800 text-sm font-semibold transition">
//                                 Retry <RefreshCw className="w-3 h-3 inline ml-1 align-sub" />
//                             </button>
//                         </div>
//                     )}
//                 </div>
//             );
//         }


//         switch (activeScreen) {
//             case 'home':
//                 return <HomeApp setActiveScreen={navigateToScreen} />;
//             case 'meter_application':
//                 return <NewMeterApplicationWrapper onBack={() => navigateToScreen('home')} setActiveScreen={navigateToScreen} />;
//             case 'active_application':
//                 return <ActiveApplicationWrapper onBack={() => navigateToScreen('home')} setActiveScreen={navigateToScreen} />;
//             case 'payment':
//                 return <PayBillScreen setActiveScreen={navigateToScreen} />;
//             case 'paymentebill':
//                 return <PayEBill onBack={() => navigateToScreen('payment')} setActiveScreen={navigateToScreen} />;
//             case 'paymentEBillProviderDetails':
//                 return <PayEBillProviderDetails onBack={() => navigateToScreen('paymentebill')} />;
//             case 'orders':
//                 return <MarketplaceScreen setActiveScreen={navigateToScreen} authToken={authToken} />;
//             case 'marketplaceProductView':
//                 // The ProductViewWrapper handles both product detail and checkout views internally,
//                 // but its navigation methods must be aligned with DashApp's state management.
//                 // onBack goes to the Marketplace ('orders')
//                 return <ProductViewWrapper onBack={() => navigateToScreen('orders')} setActiveScreen={navigateToScreen} productId={selectedProductId} />;
//             case 'checkoutView':
//                 // This screen is also handled by the ProductViewWrapper component, 
//                 // but setting a distinct state allows us to hide the Nav Bar.
//                 // onBack goes to the Product View detail page ('marketplaceProductView')
//                 return <ProductViewWrapper onBack={() => navigateToScreen('marketplaceProductView')} setActiveScreen={navigateToScreen} productId={selectedProductId} authToken={authToken}/>;
//             case 'profile':
//                 return <ProfileScreen setActiveScreen={navigateToScreen} authToken={authToken} userSession={userSession} />;
//             case 'order': // The 'My order' screen
//                 return <OrderScreen onBack={() => navigateToScreen('profile')} authToken={authToken}/>;
//             case 'kycupdate': // The 'My order' screen
//                 return <KycUpdate onBack={() => navigateToScreen('profile')} />;
//             case 'signout': // New case for Sign Out
//                 handleSignOut();
//                 return null;
//             default:
//                 return (
//                     <div className="p-8 text-center text-gray-500 flex-1 flex flex-col items-center justify-center">
//                         <Settings className="w-10 h-10 mb-4" />
//                         <h1 className="text-xl font-bold capitalize">{activeScreen} Screen</h1>
//                         <p>This screen is a placeholder.</p>
//                         <button onClick={handleSignOut} className="mt-4 text-red-500 underline">Force Sign Out</button>
//                     </div>
//                 );
//         }
//     };

//     // Component for a single navigation item
//     const NavItem = ({ iconName, screenName }) => {
//         const isActive = activeScreen === screenName
//         const Icon = NavIconMap[iconName];

//         const colorClass = isActive ? 'text-blue-600' : 'text-gray-500 hover:text-blue-700';
//         const bgClass = isActive ? 'bg-blue-50/50' : 'bg-transparent';
//         const shadowClass = isActive ? 'shadow-inner' : '';

//         return (
//             <button
//                 className={`flex flex-col items-center justify-center w-1/4 py-2 transition-colors duration-200`}
//                 onClick={() => setActiveScreen(screenName)}
//             >
//                 <div className={`p-1.5 rounded-xl ${bgClass} ${shadowClass} transition-all`}>
//                     <Icon className={`w-6 h-6 ${colorClass}`} strokeWidth={2.2} />
//                 </div>
//             </button>
//         );
//     };

//     // Check if the current screen should hide the bottom navigation bar
//     const isOrderScreen = (
//         activeScreen === 'order' ||
//         activeScreen === 'kycupdate' ||
//         activeScreen === 'paymentEBillProviderDetails' ||
//         activeScreen === 'marketplaceProductView' ||
//         activeScreen === 'checkoutView' ||
//         activeScreen === 'meter_application' ||
//         activeScreen === 'active_application' ||
//         isLoading // Hide nav bar while loading session
//     );

//     return (
//         <div className="min-h-screen flex justify-center bg-gray-200">
//             <div className="relative w-full max-w-md flex flex-col min-h-screen bg-gray-50 shadow-2xl">

//                 {/* Screen Rendering Area */}
//                 <div className="flex-1 overflow-y-auto pb-20">
//                     {renderScreen()}
//                 </div>

//                 {/* Conditional Navigation Bar */}
//                 {!isOrderScreen && (
//                     <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-2xl p-3 z-30 max-w-md mx-auto rounded-t-2xl">
//                         <div className="flex justify-around items-center h-full">
//                             <NavItem iconName="home" screenName="home" />
//                             <NavItem iconName="payment" screenName="payment" />
//                             <NavItem iconName="orders" screenName="orders" />
//                             <NavItem iconName="profile" screenName="profile" />
//                         </div>
//                     </nav>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default DashApp

// <------------new 1------------->



// -----------------------

// -----------------------
function useNetworkStatus() {
    const [isOnline, setIsOnline] = useState(true);
    const initialized = useRef(false);

    useEffect(() => {
        let listener = null;

        const init = async () => {
            try {
                const status = await Network.getStatus();
                setIsOnline(Boolean(status.connected));

                listener = Network.addListener('networkStatusChange', (stat) => {
                    setIsOnline(Boolean(stat.connected));
                });
            } catch (err) {
                // Fallback to navigator if Capacitor not available
                setIsOnline(Boolean(navigator.onLine));

                const handleOnline = () => setIsOnline(true);
                const handleOffline = () => setIsOnline(false);
                window.addEventListener('online', handleOnline);
                window.addEventListener('offline', handleOffline);

                // cleanup for navigator listeners
                return () => {
                    window.removeEventListener('online', handleOnline);
                    window.removeEventListener('offline', handleOffline);
                };
            }
        };

        if (!initialized.current) {
            init();
            initialized.current = true;
        }

        return () => {
            if (listener && typeof listener.remove === 'function') listener.remove();
        };
    }, []);

    return isOnline;
}

// -----------------------
// Hook: useSession
// Manages fetching, caching, and refreshing session
// -----------------------
function useSession({ authToken, setAuthToken, setUserSession, initialUserSession }) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    // Load cached session instantly if available
    useEffect(() => {
        try {
            const cached = localStorage.getItem('userSession');
            if (cached && !initialUserSession) {
                setUserSession(JSON.parse(cached));
            }
        } catch (err) {
            // ignore
        }
    }, []); // run once

    const fetchSession = useCallback(async () => {
        if (!authToken) {
            setError('No auth token');
            // throw new Error('NO_AUTH');
            return null;
        }

        setIsLoading(true);
        setError(null);

        try {
            const response = await fetch(SESSION_API_URL, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.status === 401) {
                // throw new Error('SESSION_INVALID');
                 setError('SESSION_INVALID');
            }

            const result = await response.json();

            if (response.ok && result?.data?.user) {
                setUserSession(result.data.user);
                try {
                    localStorage.setItem('userSession', JSON.stringify(result.data.user));
                } catch (err) {
                    // ignore storage errors
                }
                setError(null);
                return result.data.user;
            } else {
                const msg = result?.message || 'Session validation failed';
                setError(msg);
                // throw to allow outer handling
                throw new Error(msg);
            }
        } catch (err) {
            setError(err.message || 'Network error while verifying session');
            throw err;
        } finally {
            setIsLoading(false);
        }
    }, [authToken, setUserSession]);

    const clearSession = useCallback(() => {
        try {
            localStorage.removeItem('authToken');
            localStorage.removeItem('userSession');
        } catch (err) {
            // ignore
        }
        setAuthToken(null);
        setUserSession(null);
    }, [setAuthToken, setUserSession]);

    return { isLoading, error, fetchSession, clearSession };
}

// -----------------------
// Main Component: DashApp
// -----------------------
export default function DashApp({ setAuthToken, setUserSession, userSession, authToken }) {
    const navigate = useNavigate();


    const [activeScreen, setActiveScreen] = useState('home');
    const [selectedProductId, setSelectedProductId] = useState(null);

    // 🚨 FIX: New state variables for Bill Payment flow
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [selectedCategoryName, setSelectedCategoryName] = useState(null)

    const [selectedBillerId, setSelectedBillerId] = useState(null);
    const [selectedBillerName, setSelectedBillerName] = useState(null)

    const isOnline = useNetworkStatus();

    // session hook
    const { isLoading, error, fetchSession, clearSession } = useSession({
        authToken,
        setAuthToken,
        setUserSession,
        initialUserSession: userSession,
    });

    // local transient state for showing banners
    const [showOnlineBanner, setShowOnlineBanner] = useState(false);
    useEffect(() => {
        if (isOnline) {
            setShowOnlineBanner(true);
            const t = setTimeout(() => setShowOnlineBanner(false), 2200);
            return () => clearTimeout(t);
        }

        console.log('offline scname', activeScreen)
    }, [isOnline]);

    // navigateToScreen centralizes navigation and payload handling
    const navigateToScreen = (screenName, payload = {}) => {
        setActiveScreen(screenName);

        if (screenName === 'marketplaceProductView' || screenName === 'checkoutView') {
            setSelectedProductId(payload.productId || payload.id || selectedProductId);
        } else {
            setSelectedProductId(null);
        }


        // 🚨 FIX: Logic for Bill Payment flow
        if (payload.categoryId) {
            setSelectedCategoryId(payload.categoryId);
        } else if (screenName !== 'paymentEBillProviderDetails' && screenName !== 'paymentebill') {
            // Clear category ID if navigating away from the bill flow
            setSelectedCategoryId(null);
        }

        if (payload.categoryName) {
            setSelectedCategoryName(payload.categoryName);
        } else if (screenName !== 'paymentEBillProviderDetails' && screenName !== 'paymentebill') {
            setSelectedCategoryName(null);
        }

        if (payload.billerId) {
            setSelectedBillerId(payload.billerId);
        } else if (screenName !== 'paymentEBillProviderDetails' && screenName !== 'paymentebill') {
            setSelectedBillerId(null);
        }
        if (payload.billerName) {
            setSelectedBillerName(payload.billerName);
        } else if (screenName !== 'paymentEBillProviderDetails' && screenName !== 'paymentebill') {
            setSelectedBillerName(null);
        }
    };

    // ✅ BACK HANDLER (ANDROID + PWA SAFE)
    useBackHandler(activeScreen, navigateToScreen);

    const handleSignOut = useCallback(() => {
        clearSession();
        // redirect to sign-in route — replace with your route
        navigate('/signin');
    }, [clearSession, navigate]);

    // Auto retry session when network is back
    useEffect(() => {
        if (isOnline && authToken && !userSession) {
            // attempt to refresh session silently
            // fetchSession().catch((err) => {
            //     // if session invalid, sign out
            //     if (err.message && /Session validation failed|No auth token/.test(err.message)) {
            //         handleSignOut();
            //     }
            // });
            fetchSession().catch((err) => {
                if (err.message === 'SESSION_INVALID' || err.message === 'No auth token') {
                    handleSignOut();
                }
            })
        }
    }, [isOnline, authToken, userSession, fetchSession, handleSignOut]);

    // If token disappears, sign out
    useEffect(() => {
        if (!authToken) {
            handleSignOut();
        }
    }, [authToken]);




    // Top-level render function with offline-first behavior
    const renderScreen = () => {
        // Offline UI (still allow pull-to-refresh to retry)
        if (!isOnline) {
            return (
                <div className="min-h-full flex flex-col items-center justify-center p-6 text-center flex-1 bg-white">
                    <WifiOff className="w-12 h-12 text-red-500 mb-4" />
                    <p className="text-xl font-bold text-gray-800 mb-2">You are Offline</p>
                    <p className="text-gray-600 mb-4">Please check your internet connection.</p>
                    <button
                        onClick={() => fetchSession().catch(() => { })}
                        className="text-blue-600 font-semibold flex items-center"
                    >
                        Retry <RefreshCw className="w-4 h-4 ml-2" />
                    </button>
                </div>
            );
        }

        if (isLoading || !userSession) {
            return (
                <div className="min-h-full flex flex-col items-center justify-center p-6 text-center flex-1">
                    <Loader2 className="w-8 h-8 text-blue-600 mb-4 animate-spin" />
                    <p className="text-gray-600">Verifying session...</p>
                    {error && (
                        <div className="mt-4 p-3 bg-red-100 text-red-700 rounded-xl w-full max-w-sm">
                            <p className="font-medium mb-2">{error}</p>
                            <button onClick={() => fetchSession().catch(() => { })} className="text-blue-600 hover:text-blue-800 text-sm font-semibold transition">
                                Retry <RefreshCw className="w-3 h-3 inline ml-1 align-sub" />
                            </button>
                        </div>
                    )}
                </div>
            );
        }

        // When online and session present, render according to activeScreen
        switch (activeScreen) {
            case 'home':
                return <HomeApp setActiveScreen={navigateToScreen} />;
            case 'meter_application':
                return <NewMeterApplicationWrapper onBack={() => navigateToScreen('home')} setActiveScreen={navigateToScreen} />;
            // case 'active_application':
            //     return <ActiveApplicationWrapper onBack={() => navigateToScreen('home')} setActiveScreen={navigateToScreen} />;
            case 'payment':
                return <PayBillScreen setActiveScreen={navigateToScreen} authToken={authToken} handleSignOut={handleSignOut} />;
            case 'paymentebill':
                return <SelectBillerScreen onBack={() => navigateToScreen('payment')} setActiveScreen={navigateToScreen} categoryId={selectedCategoryId}
                    categoryName={selectedCategoryName} authToken={authToken} />;
            case 'paymentEBillProviderDetails':
                return <PayEBillProviderDetails onBack={() => navigateToScreen('paymentebill')} setActiveScreen={navigateToScreen} userSession={userSession}
                    categoryId={selectedCategoryId}
                    categoryName={selectedCategoryName}
                    billerId={selectedBillerId}
                    billerName={selectedBillerName}
                    authToken={authToken} />;
            case 'orders':
                return <MarketplaceScreen setActiveScreen={navigateToScreen} authToken={authToken} handleSignOut={handleSignOut}/>;
            case 'marketplaceProductView':
                return (
                    <ProductViewWrapper
                        onBack={() => navigateToScreen('orders')}
                        setActiveScreen={navigateToScreen}
                        productId={selectedProductId}
                        authToken={authToken}
                        userSession={userSession}
                    />
                );
            case 'checkoutView':
                return (
                    <ProductViewWrapper
                        onBack={() => navigateToScreen('marketplaceProductView')}
                        setActiveScreen={navigateToScreen}
                        productId={selectedProductId}
                        authToken={authToken}
                    />
                );
            case 'profile':
                return <ProfileScreen setActiveScreen={navigateToScreen} authToken={authToken} userSession={userSession} onLogoutSuccess={handleSignOut} />;
            case 'order':
                return <OrderScreen onBack={() => navigateToScreen('profile')} authToken={authToken} />;
            case 'kycupdate':
                return <SelfieCaptureScreen onBack={() => navigateToScreen('profile')} />;
            case 'signout':
                handleSignOut();
                return null;
            default:
                return (
                    <div className="p-8 text-center text-gray-500 flex-1 flex flex-col items-center justify-center">
                        <Settings className="w-10 h-10 mb-4" />
                        <h1 className="text-xl font-bold capitalize">{activeScreen} Screen</h1>
                        <p>This screen is a placeholder.</p>
                        <button onClick={handleSignOut} className="mt-4 text-red-500 underline">Force Sign Out</button>
                    </div>
                );
        }
    };

    // Bottom nav visibility logic
    const isOrderScreen = (
        activeScreen === 'order' ||
        activeScreen === 'kycupdate' ||
        // activeScreen === 'paymentebill' ||
        activeScreen === 'paymentEBillProviderDetails' ||
        activeScreen === 'marketplaceProductView' ||
        activeScreen === 'checkoutView' ||
        activeScreen === 'meter_application' ||
        activeScreen === 'active_application' ||
        isLoading
    );

    const NavItem = ({ iconName, screenName }) => {
        const isActive = activeScreen === screenName;
        const Icon = NavIconMap[iconName] || Settings;
        const colorClass = isActive ? 'text-blue-600' : 'text-gray-500 hover:text-blue-700';
        const bgClass = isActive ? 'bg-blue-50/50' : 'bg-transparent';
        const shadowClass = isActive ? 'shadow-inner' : '';

        return (
            <button
                className={`flex flex-col items-center justify-center w-1/4 py-2 transition-colors duration-200`}
                onClick={() => navigateToScreen(screenName)}
            >
                <div className={`p-1.5 rounded-xl ${bgClass} ${shadowClass} transition-all`}>
                    <Icon className={`w-6 h-6 ${colorClass}`} strokeWidth={2.2} />
                </div>
            </button>
        );
    };

    return (
        <div className="min-h-screen flex justify-center bg-gray-200">
            <div className="relative w-full max-w-md flex flex-col min-h-screen bg-gray-50 shadow-2xl">

                {/* Top Banners */}
                {showOnlineBanner && isOnline && (
                    <div className="fixed top-3 left-1/2 transform -translate-x-1/2 z-40 bg-green-600 text-white px-4 py-2 rounded-full text-sm shadow-lg">
                        Back Online
                    </div>
                )}

                {!isOnline && (
                    <div className="fixed top-3 left-1/2 transform -translate-x-1/2 z-40 bg-red-600 text-white px-4 py-2 rounded-full text-sm shadow-lg">
                        No Internet Connection
                    </div>
                )}

                {/* Screen Rendering Area with PullToRefresh */}
                {/* <PullToRefresh
    onRefresh={fetchSession}
    pullDownThreshold={120}
    shouldPullToRefresh={() => window.scrollY === 0}
>
    <div 
        className="overflow-y-auto"
        style={{ height: "calc(100vh - 50px)" }}
    >
        {renderScreen()}
    </div>
</PullToRefresh> */}
                <div className="flex-1 overflow-y-auto pb-20">
                    {renderScreen()}
                </div>


                {/* Conditional Navigation Bar */}
                {!isOrderScreen && (
                    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-2xl p-3 z-30 max-w-md mx-auto rounded-t-2xl">
                        <div className="flex justify-around items-center h-full">
                            <NavItem iconName="home" screenName="home" />
                            <NavItem iconName="payment" screenName="payment" />
                            <NavItem iconName="orders" screenName="orders" />
                            <NavItem iconName="profile" screenName="profile" />
                        </div>
                    </nav>
                )}
            </div>
        </div>
    );
}
